<template>
  <div class="loch-container">
    <main class="main-content">
      <h1>Wie ist dieses Laubloch?</h1>
      <div class="flex_row">
        <div class="center">
          <button class="arrow-button" v-if="showStats" style="opacity: 0;">
            <img src="/assets/svgs/direction=Rechtes.svg" alt="Weiter" />
          </button>
        </div>
        <div class="loch-shape" :class="{ 'max-size': showStats }">
          <svg ref="lochSvg" id="morph-svg" viewBox="0 0 1000 1000" preserveAspectRatio="xMidYMid meet">
            <path :d="currentPath" fill="currentColor" id="morph-path" />
          </svg>
        </div>
        <div class="center">
          <button class="arrow-button" @click="nextShape" v-if="showStats">
            <img src="/assets/svgs/direction=Rechtes.svg" alt="Weiter" />
          </button>
        </div>
      </div>
    </main>

    <!-- Updated slider container structure -->
<footer class="footer">
  <div class="stats-container" v-if="showStats">
    <canvas ref="statsChart" height="150"></canvas>
  </div>
  
  <!-- Loop through categories -->
  <div v-for="cat in categories" :key="cat.category_id" class="slider-container">
    <h2>{{ cat.start_word }}</h2>
    <input
      class="slider"
      type="range"
      min="0"
      max="100"
      v-model="cat.value"
      :disabled="cat.disabled"
      @input="updateSliderBackground($event)"
      @change="onSliderRelease(cat.category_id, shapeId)"
    />
    <h2>{{ cat.end_word }}</h2>
  </div>
</footer>
    <div class="konto">
      <h3 class="konto">Konto: {{ konto }}</h3>
    </div>
  </div>
</template>

<script>
import '../styles/formenBewerter.css';
import Chart from 'chart.js/auto';
import { gsap } from 'gsap';
import * as flubber from 'flubber';
import svgPathsData from './preprocessed_paths.json';
import sessionKonto from '../js/sessionKonto'; // unser kleines Modul



// Add this to your FormenBewerter.vue component
// This code checks if initialHoleData is available from the loading animation

import { onMounted, ref } from 'vue';

// Add in your setup function:
const currentHole = ref(null);

onMounted(() => {
  // Try to get the preloaded hole data from window object
  if (window.getInitialHoleData && window.getInitialHoleData()) {
    currentHole.value = window.getInitialHoleData();
  } else {
    // If not available, load hole with ID 444
    loadSpecificHole(444);
  }
});

const loadSpecificHole = (holeId) => {
  // Your existing logic to load a specific hole
  fetch(`https://laubloch.de/backend/getHole.php?id=${holeId}`)
    .then(response => response.json())
    .then(data => {
      currentHole.value = data;
    })
    .catch(error => {
      console.error('Error loading specific hole:', error);
      // Fallback logic
    });
};

if (/Android/i.test(navigator.userAgent)) {
    document.documentElement.classList.add('android');
  }
  
export default {
  name: "FormenBewerter",
  data() {
    return {
      currentPath: "",
      svgPathsData,
      categories: [],
      selectedCategory: null,
      showStats: false,
      stats: [],
      shapeId: null,
      startTime: null,
      chartInstance: null,
      progress: 0,
      handleKeyDown: null,
      userId: null,
      userRatings: 0,
      resizeObserver: null,
      cameFromChooser: false
    };
  },
  watch: {
    konto(val) {
      if (this.cameFromChooser) {
        this.cameFromChooser = false;
        return;
      }
      if ([5, 13, 34, 55, 89, 144, 233, 377, 610, 987, 1597].includes(val)) {
        this.$router.push({ name: "CategoryChooser" });
      }
    }
  },
  computed: {
    konto() {
      return this.userId ? this.userRatings : sessionKonto.value;
    }
  },
  mounted() {
    if (this.$route.query.selectedCategory) {
      this.cameFromChooser = true;
      try {
        this.selectedCategory = JSON.parse(this.$route.query.selectedCategory);
        const newQuery = { ...this.$route.query };
        delete newQuery.selectedCategory;
        this.$router.replace({ query: newQuery });
      } catch (e) {
        console.error("Fehler beim Parsen der ausgewählten Kategorie:", e);
        this.cameFromChooser = false;
      }
    }

    this.initializeComponent();
    // Kategorien laden
    this.fetchCategories();
    
    this.$nextTick(() => {
      document.querySelectorAll(".slider").forEach((slider) => {
        slider.value = 50;
        this.updateSliderBackground({ target: slider });
      });
      
      // Add this line to initialize the dynamic positioning
      this.updateSliderVariables();
      this.setupResizeObserver();
    });
    
    this.fetchCategories();
    this.loadShape();

    this.handleKeyDown = this.onKeyDown.bind(this);
    window.addEventListener("keydown", this.handleKeyDown);
    
    // Add this line to handle window resize
    window.addEventListener('resize', this.updateLayout);
  },
  unmounted() {
    window.removeEventListener("keydown", this.handleKeyDown);
    window.removeEventListener('resize', this.updateLayout);
    
    // Clean up the resize observer
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    // Add these new methods
  // Add these modified methods to your Vue component

updateSliderVariables() {
  // Check if we should use the dynamic layout (screen > 500px)
  if (window.innerWidth <= 500) {
    // On small screens, set the flag to disable dynamic layout
    document.documentElement.style.setProperty('--use-dynamic-layout', '0');
    return; // Don't update other variables
  }
  
  // On larger screens, enable dynamic layout
  document.documentElement.style.setProperty('--use-dynamic-layout', '1');
  
  // Get the actual width of the slider
  const sliders = document.querySelectorAll('.slider');
  if (sliders.length > 0) {
    const sliderWidth = sliders[0].offsetWidth;
    const sliderHalfWidth = sliderWidth / 2;
    
    // Update CSS variables
    document.documentElement.style.setProperty('--slider-width', `${sliderWidth}px`);
    document.documentElement.style.setProperty('--slider-half-width', `${sliderHalfWidth}px`);
  }
},

setupResizeObserver() {
  // Create a ResizeObserver to watch the slider size
  this.resizeObserver = new ResizeObserver(entries => {
    // Skip updates on small screens
    if (window.innerWidth <= 500) return;
    
    for (let entry of entries) {
      if (entry.target.classList.contains('slider')) {
        const width = entry.contentRect.width;
        document.documentElement.style.setProperty('--slider-width', `${width}px`);
        document.documentElement.style.setProperty('--slider-half-width', `${width / 2}px`);
        break; // Only need to process one slider
      }
    }
  });
  
  // Observe the first slider
  const slider = document.querySelector('.slider');
  if (slider) {
    this.resizeObserver.observe(slider);
  }
},
    
    updateLayout() {
      this.updateSliderVariables();
    },
    
    
    
    
    // Your existing methods with modifications
    async initializeComponent() {
      await this.checkLoginStatus();
      if (this.userId) {
        const response = await fetch(`https://laubloch.de/backend/account.php?action=get-stats`, {
          headers: {
            'Authorization': `Bearer ${document.cookie.split('; ').find(row => row.startsWith('auth_token='))?.split('=')[1]}`
          }
        });
        const data = await response.json();
        this.userRatings = data.ratings.user;
      }
    },

    async checkLoginStatus() {
      try {
        const token = document.cookie
          .split('; ')
          .find(row => row.startsWith('auth_token='))
          ?.split('=')[1];
          
        if (!token) return;

        const response = await fetch('https://laubloch.de/backend/account.php?action=verify', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const data = await response.json();
        if (data.valid) {
          this.userId = data.user_id;
        }
      } catch (error) {
        console.error('Login check failed:', error);
      }
    },
    
    onKeyDown(event) {
      if (event.key === "ArrowRight" && this.showStats) {
        const activeElement = document.activeElement;
        const isInputActive = activeElement && (
          activeElement.tagName === "INPUT" ||
          activeElement.tagName === "TEXTAREA" ||
          activeElement.isContentEditable
        );
        if (!isInputActive) this.nextShape();
      }
    },
    
    loadShape() {
      const availableShapeIds = Object.keys(this.svgPathsData);
      if (!availableShapeIds.length) {
        console.error("No SVG paths available.");
        return;
      }
      const randomIndex = Math.floor(Math.random() * availableShapeIds.length);
      const randomNumber = parseInt(availableShapeIds[randomIndex]);
      const newPath = this.svgPathsData[randomNumber];

      if (!this.currentPath) {
        this.currentPath = newPath;
        this.shapeId = randomNumber;
        this.startTime = performance.now();
      } else {
        const interpolator = flubber.interpolate(this.currentPath, newPath, { maxSegmentLength: 2 });
        this.progress = 0;
        gsap.to(this, {
          duration: 0.5,
          progress: 1,
          onUpdate: () => {
            this.currentPath = interpolator(this.progress);
          },
          onComplete: () => {
            this.currentPath = newPath;
          },
          ease: "power2.inOut",
        });
        this.shapeId = randomNumber;
        this.startTime = performance.now();
      }
      this.showStats = false;
    },
    
    fetchCategories() {
      fetch("https://laubloch.de/backend/getCategories.php")
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "success") {
            // Ursprüngliche Kategorien einlesen
            this.categories = data.data.map(cat => ({
              ...cat,
              value: 50,
              disabled: false,
            }));
            
            // Hier ersetzt Du die "alte" Kategorie durch die neue "selectedCategory"
            if (this.selectedCategory) {
              const oldIdx = 0; // oder: this.categories.findIndex(cat => cat.category_id === x);

              if (oldIdx !== -1 && this.categories[oldIdx]) {
                // Ersetzen mit neuer Kategorie (inkl. neuer ID usw.)
                this.categories.splice(oldIdx, 1, {
                  ...this.selectedCategory,
                  value: 50,
                  disabled: false,
                });
              }
            }
            
            // Add this to update the variables after categories are loaded
            this.$nextTick(() => {
              this.updateSliderVariables();
            });

          } else {
            console.error("Error loading categories:", data.message);
          }
        })
        .catch(err => console.error("Fetch error:", err));
    },
    
    onSliderRelease(categoryId, shapeId) {
      const timeUsed = performance.now() - this.startTime;
      const category = this.categories.find(cat => cat.category_id === categoryId);
      if (!category) return;

      const payload = {
        user_id: this.userId,
        shape_id: shapeId,
        category_id: categoryId,
        rating_value: category.value, 
        time_used: timeUsed / 1000
      };

      fetch("https://laubloch.de/backend/ratingHandler.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            this.showStats = true;
            this.stats = data.data;
            this.renderStatsChart();
            if (this.userId) {
              this.userRatings += 1;
            } else {
              sessionKonto.value += 1;
            }
            category.disabled = true;
            
            // Add this to update after stats are shown
            this.$nextTick(() => {
              this.updateSliderVariables();
            });
          }
        })
        .catch(err => console.error("Fetch error:", err));
    },
    
    nextShape() {
      this.loadShape();
      this.categories.forEach(cat => {
        cat.value = 50;
        cat.disabled = false;
      });
      this.$nextTick(() => {
        document.querySelectorAll(".slider").forEach((slider) => {
          this.updateSliderBackground({ target: slider });
        });
        
        // Add this to update after shape changes
        this.updateSliderVariables();
      });
    },
    
    updateSliderBackground(event) {
      const slider = event.target;
      const value = parseInt(slider.value);
      const center = 50;

      if (value === center) {
        slider.style.background = "transparent";
      } else if (value > center) {
        slider.style.background = `
          linear-gradient(
            to right,
            transparent ${center}%,
            black ${center}%,
            black ${value}%,
            transparent ${value}%
          )
        `;
      } else {
        slider.style.background = `
          linear-gradient(
            to right,
            transparent ${value}%,
            black ${value}%,
            black ${center}%,
            transparent ${center}%
          )
        `;
      }
    },
    
    renderStatsChart() {
      this.$nextTick(() => {
        const canvas = this.$refs.statsChart;
        if (!canvas) return;
        if (this.chartInstance) this.chartInstance.destroy();

        const BIN_COUNT = 21;
        const BIN_SIZE = 5;
        const bins = Array(BIN_COUNT).fill(0);

        this.stats.forEach(stat => {
          const value = stat.rating_value;
          if (value >= 0 && value <= 100) {
            const binIndex = Math.floor(value / BIN_SIZE);
            if (binIndex >= 0 && binIndex < BIN_COUNT) bins[binIndex] += stat.count;
          }
        });

        const labels = bins.map((_, index) => {
          const start = index * BIN_SIZE;
          const end = start + BIN_SIZE - 0.01;
          return `${start}-${end}`;
        });

        const data = bins.map(count => count);
        const maxCount = Math.max(...data);
        const yMax = maxCount > 0 ? maxCount * 1.2 : 10;

        const ctx = canvas.getContext("2d");
        this.chartInstance = new Chart(ctx, {
          type: "line",
          data: {
            labels,
            datasets: [{
              data,
              borderColor: "black",
              borderWidth: 2,
              tension: 0.6,
              fill: true,
              backgroundColor: "rgba(1, 1, 1, 1)",
              pointRadius: 0,
              spanGaps: false,
            }],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              x: { display: false },
              y: { display: false, min: 0, max: yMax },
            },
            plugins: {
              legend: { display: false },
              tooltip: { enabled: true },
              title: { display: false },
            },
          },
        });
        
        // Add this to update after chart is rendered
        this.updateSliderVariables();
      });
    },
  }
};
</script>
